import { Box } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { fromISO8601_DATE, toISO8601_DATE } from "../../../../../../utils/iso8601";

import type { ISO8601_DATE } from "../../../../../../utils/iso8601";
import type { UsableAccountPersonField } from "../../../../server/supabase-segment-field-service";
import type { Condition } from "../../../../types/segment-schema";
import type { SxProps } from "@mui/material";
import type { FC } from "react";

export const DateSelectField: FC<{
  condition: Condition;
  handleFieldChange: (value: string[]) => void;
  error?: string;
  disabled?: boolean;
  segmentField?: UsableAccountPersonField;
  hidden?: boolean;
  sx?: SxProps;
}> = ({ condition, handleFieldChange, error, disabled, segmentField, hidden, sx }) => (
  <Box hidden={hidden}>
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DatePicker
        // oxlint-disable-next-line typescript/no-unsafe-type-assertion
        value={condition.values[0] ? fromISO8601_DATE(condition.values[0] as ISO8601_DATE) : null}
        onChange={(value: Date | null) => {
          handleFieldChange(value ? [toISO8601_DATE(value)!] : []);
        }}
        slotProps={{
          textField: {
            label: segmentField?.display_name,
            error: Boolean(error),
            helperText: error,
            variant: "standard",
            hidden,
            size: "small",
          },
        }}
        disabled={disabled}
        sx={sx}
      />
    </LocalizationProvider>
  </Box>
);
